import { initializeApp } from "firebase/app";
import { getMessaging, getToken, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDndnxsZ5Ur0RIYxeDA-pxkqrIAEVk-2uw",
  authDomain: "farmology-saas-87c43.firebaseapp.com",
  projectId: "farmology-saas-87c43",
  storageBucket: "farmology-saas-87c43.firebasestorage.app",
  messagingSenderId: "594879023548",
  appId: "1:594879023548:web:cd9bec49bbf739957a83b9",
  measurementId: "G-JW18VG6G4B",
};

const vapidKey =
  "BNYS8-nBbDrBzd4Yv1ZytaZXBVhfVAj68AZnWYG_KgCMDZk4P58DGP_KuawEAa41OWOQXDGTDnKt63ugn1R4DNs";

let app;
let messaging;

try {
  app = initializeApp(firebaseConfig);
  console.log("Firebase app initialized successfully.");
} catch (error) {
  console.error("Error initializing Firebase app: ", error);
}

try {
  isSupported()
    .then((supported) => {
      if (supported) {
        messaging = getMessaging(app);
        console.log("Firebase Messaging initialized successfully.");
      } else {
        console.warn("Firebase Messaging is not supported in this browser.");
      }
    })
    .catch((error) => {
      console.error("Error checking Firebase Messaging support:", error);
    });
} catch (error) {
  console.error("Error initializing Firebase Messaging: ", error);
}

export const requestFCMToken = async () => {
  try {
    console.log("Requesting notification permission...");
    const permission = await Notification.requestPermission();

    if (permission === "granted") {
      console.log("Notification permission granted. Requesting FCM token...");
      try {
        const token = await getToken(messaging, { vapidKey: vapidKey });
        console.log("FCM Token retrieved successfully:", token);
        return token;
      } catch (tokenError) {
        console.error("Error retrieving FCM Token: ", tokenError);
        throw tokenError;
      }
    } else {
      console.warn("Notification permission denied.");
      throw new Error("Permission denied");
    }
  } catch (permissionError) {
    console.error(
      "Error during notification permission request:",
      permissionError
    );
    throw permissionError;
  }
};
